import { Request, Response, NextFunction } from 'express';

export function getFlagName (key: string): string | null {
  const match = key.match(/^feature-flag-(([a-z0-9]-?)+)$/);
  return match ? match[1] : null;
}

export function isFeatureFlag (key: string): boolean {
  return !!getFlagName(key);
}

export function isEnabled (value: string): boolean {
  return (value === '1' || value === 'enabled');
}

export default function (req: Request, res: Response, next: NextFunction) {
  Object.keys(req.query || {}).forEach(key => {
    if (isFeatureFlag(key)) {
      const value = isEnabled((req.query[key] || '').toString()) ? 'enabled' : 'disabled';
      req.cookies[key] = value;
      res.cookie(key, value, { sameSite: 'none', secure: true });
    }
  });

  next();
}
